import { db } from "../../shared/config";
import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  startAfter,
  endBefore,
  limitToLast,
  limit,
  Timestamp,
  where,
} from "firebase/firestore";
import {
  GET_VOLUNTEERREQUESTS,
  ADD_VOLUNTEERREQUEST,
  GET_VOLUNTEERREQUEST,
  RESET_VOLUNTEERREQUEST,
  VOLUNTEERREQUESTS_ERROR,
} from "../types/volunteerrequest_type";

import { setAlert } from "./alert";
import { LIMIT } from "../../domain/constant";
//GET VOLUNTEERREQUESTS
const volunteerrequestsRef = collection(db, "volunteerrequests");
export const getVolunteerrequests =
  ({ term, termField, orderValue = "createdAt", orderType = "desc" }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(volunteerrequestsRef, where(termField, "==", term));
      } else {
        searchQuery = query(
          volunteerrequestsRef,
          orderBy(orderValue, orderType),
          limit(LIMIT)
        );
      }
      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_VOLUNTEERREQUESTS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: VOLUNTEERREQUESTS_ERROR,
      });
    }
  };

export const getNextVolunteerrequests =
  ({ term, termField, last, orderValue = "createdAt", orderType = "desc" }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(
          volunteerrequestsRef,
          orderBy(orderValue, orderType),
          startAfter(last[orderValue]),
          limit(LIMIT),
          where(termField, "==", term)
        );
      } else {
        searchQuery = query(
          volunteerrequestsRef,
          orderBy(orderValue, orderType),
          startAfter(last[orderValue]),
          limit(LIMIT)
        );
      }
      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_VOLUNTEERREQUESTS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: VOLUNTEERREQUESTS_ERROR,
      });
    }
  };
export const getPreviousVolunteerrequests =
  ({ term, termField, first, orderValue = "createdAt", orderType = "desc" }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(
          volunteerrequestsRef,
          orderBy(orderValue, orderType),
          endBefore(first[orderValue]),
          limitToLast(LIMIT),
          where(termField, "==", term)
        );
      } else {
        searchQuery = query(
          volunteerrequestsRef,
          orderBy(orderValue, orderType),
          endBefore(first[orderValue]),
          limitToLast(LIMIT)
        );
      }

      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_VOLUNTEERREQUESTS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: VOLUNTEERREQUESTS_ERROR,
      });
    }
  };

export const addVolunteerrequest = (data) => async (dispatch) => {
  try {
    data.createdAt = Timestamp.fromDate(new Date());
    const docRef = await addDoc(volunteerrequestsRef, data);
    dispatch({
      type: ADD_VOLUNTEERREQUEST,
    });
    dispatch(setAlert("Volunteerrequest added successfully", "success"));
  } catch (e) {
    console.error("Error adding document: ", e);
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: VOLUNTEERREQUESTS_ERROR,
    });
  }
};

export const getVolunteerrequest = (id) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_VOLUNTEERREQUEST,
    });
    const docRef = doc(db, "volunteerrequests", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      data.id = id;
      dispatch({
        type: GET_VOLUNTEERREQUEST,
        payload: data,
      });
    } else {
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: VOLUNTEERREQUESTS_ERROR,
      });
    }
  } catch (err) {
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: VOLUNTEERREQUESTS_ERROR,
    });
  }
};
export const editVolunteerrequest = (id, data) => async (dispatch) => {
  try {
    const docSnap = await updateDoc(doc(db, "volunteerrequests", id), data);
    dispatch(setAlert("Volunteerrequest updated successfully", "success"));
  } catch (err) {
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: VOLUNTEERREQUESTS_ERROR,
    });
  }
};

export const deleteVolunteerrequest = (id) => async (dispatch) => {
  try {
    const docSnap = await deleteDoc(doc(db, "volunteerrequests", id));
    dispatch(setAlert("Volunteerrequest deleted successfully", "success"));
  } catch (err) {
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: VOLUNTEERREQUESTS_ERROR,
    });
  }
};
